﻿/**
 * Accurate Cart Preview System
 * Main entry point for cart preview rendering with print area clipping
 */
import { AccurateCartPreviewRenderer } from './product-cart-accurate-cart-preview-renderer.js';
import { CartPreviewInitializer } from './product-cart-cart-preview-initializer.js';
import { CartDataFetcher } from './product-cart-cart-data-fetcher.js';

const CART_PREVIEW_BOOTSTRAP_FLAG = '__ACCURATE_CART_PREVIEW_BOOTSTRAPPED__';

// Auto-initialize on cart page
if (window.location.pathname.includes('/cart')) {
  if (window[CART_PREVIEW_BOOTSTRAP_FLAG]) {
    console.log('Accurate cart preview already initialized, skipping duplicate bootstrap');
  } else {
    window[CART_PREVIEW_BOOTSTRAP_FLAG] = true;

    const start = async () => {
      try {
        console.log('Starting accurate cart preview system');

        // Fetch cart data first
        await CartDataFetcher.fetchCart();

        // Initialize all previews
        await CartPreviewInitializer.initializeAll();

        console.log('Accurate cart preview system initialized');
      } catch (error) {
        console.error('Failed to initialize cart previews:', error);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      // DOM already parsed
      start();
    }
  }
}

// Export for manual use
window.AccurateCartPreview = {
  Renderer: AccurateCartPreviewRenderer,
  Initializer: CartPreviewInitializer,
  DataFetcher: CartDataFetcher
};

console.log('Accurate cart preview module loaded');
